import './UniWidgetSummaryReport.scss';
import eyeGreen from '../../assets/icons/eye-green.svg';
import eyeGray from '../../assets/icons/eye-gray.svg';
import { useTranslation } from 'react-i18next';

export type UniWidgetSummaryReportProps = {
    title: string,
    iconImg: string,
    iconBackgroundColor: string,
    value: number,
    buttonValue: number,
    valueFontSize?: number,
    isButtonActive: boolean,
    valueDetail?: string,
    valueDetailTwo?: string,
    onButtonClick: () => void
};

const UniWidgetSummaryReport = (props: UniWidgetSummaryReportProps) => {

    const { t } = useTranslation();

    return (
        <>
            <div className='uni-widget-summary-report'>
                <div className='uni-widget-summary-report-title'>{props.title}</div>
                <div className='uni-widget-summary-report-body'>
                    <div className='uni-widget-summary-report-icon' style={{ backgroundColor: props.iconBackgroundColor }}>
                        <img src={props.iconImg} alt='iconImg' />
                    </div>
                        <div className='valuesArea'>
                            <div>
                                <span className='uni-widget-summary-report-value' style={{ fontSize: (props.valueFontSize ? props.valueFontSize : 40) + 'px'}}>
                                    {props.value} <span className='uni-widget-summary-report-value-ton'>t</span>
                                </span>
                            </div>
                            <div> {props.valueDetail ?? <span>{ props.valueDetail }</span> }</div>
                            <div> {props.valueDetailTwo ?? <span>{ props.valueDetailTwo }</span>}</div>
                        </div>

                    <div className='uni-widget-summary-report-button-wrapper'>
                        <span className='uni-widget-summary-report-button-title'>{t('report.totalOrders')}</span>
                        <button className={props.isButtonActive ? 'active': '' } onClick={() => {
                            props.onButtonClick();
                        }}>
                            {
                                props.isButtonActive && <img src={eyeGreen} alt='eyeGreen' />
                            }
                            {
                                !props.isButtonActive && <img src={eyeGray} alt='eyeGray' />
                            }
                            <span className='uni-widget-summary-report-button-value'>{props.buttonValue}</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UniWidgetSummaryReport;